import { render, staticRenderFns } from "./fileGrid.vue?vue&type=template&id=63635538&scoped=true"
import script from "./fileGrid.vue?vue&type=script&lang=js"
export * from "./fileGrid.vue?vue&type=script&lang=js"
import style0 from "./fileGrid.vue?vue&type=style&index=0&id=63635538&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63635538",
  null
  
)

export default component.exports